import { view } from '@yola/ws-sdk';
import { elementStylesMap, LINE_HEIGHT_AUTO_DIFF_VALUE } from '../constants/element-customization';
import lineHeightMap from '../../extensions/registry/ws-text-formatting/constants/line-height-map';

const cutUnit = (value, unit) => {
  if (value.endsWith(unit)) {
    return value.slice(0, -unit.length);
  }

  return value;
};

const getComputedValue = (key, value) => {
  let computedValue = value;

  if (value.startsWith('var')) {
    const liveDocument = view.accessors.getLiveDocument();
    computedValue = getComputedStyle(liveDocument.documentElement).getPropertyValue(
      value.slice(4, -1).trim()
    );
  }

  if (key.endsWith(elementStylesMap.FONT_FAMILY)) {
    return computedValue.split(',')[0].replace(/['"]/g, '');
  }

  if (key.endsWith(elementStylesMap.FONT_SIZE)) {
    return cutUnit(computedValue, 'px');
  }

  if (key.endsWith(elementStylesMap.LINE_HEIGHT)) {
    return cutUnit(computedValue, 'em');
  }

  return computedValue;
};

const getDefaultElementsStylesValues = (variables, modifiedVariables = []) => {
  const filteredVariablesMap = {};

  Object.entries(variables).forEach(([key, value]) => {
    if (Object.values(elementStylesMap).some((style) => key.endsWith(style))) {
      if (modifiedVariables.includes(key)) {
        filteredVariablesMap[key] = getComputedValue(key, value);
        return;
      }

      if (key.endsWith(elementStylesMap.LINE_HEIGHT)) {
        const computedValue = getComputedValue(key, value);

        if (Object.values(lineHeightMap).includes(computedValue)) {
          // we need to add a small value to prevent matching with default options in line height select
          // for line heights that are equal to "Auto" option value and trigger "Custom" option instead
          filteredVariablesMap[key] = String(+computedValue + LINE_HEIGHT_AUTO_DIFF_VALUE);
        } else {
          filteredVariablesMap[key] = computedValue;
        }

        return;
      }

      if (key.endsWith(elementStylesMap.LETTER_SPACING)) {
        filteredVariablesMap[key] = '0em';
        return;
      }

      filteredVariablesMap[key] = getComputedValue(key, value);
    }
  });

  return filteredVariablesMap;
};

export { getComputedValue };
export default getDefaultElementsStylesValues;
